import BaseModel from "./BaseModel";
import { action, makeObservable, observable } from "mobx";
import { post } from "../common/requester";

export default class Award extends BaseModel {
  constructor(store) {
    super(store);

    makeObservable(this, {
      company_id: observable,
      tournament_id: observable,
      game_id: observable,
      team_class_id: observable,

      sport_id: observable,
      scope: observable,
      include_common: observable,

      award_types: observable,
      awards: observable,

      setContext: action,
      setTypeFilter: action,

      getAwardTypes: action,
      listAwards: action,
      createAward: action,
      updateAward: action,
      deleteAward: action
    });
  }

  company_id = 0;
  tournament_id = null;
  game_id = null;
  team_class_id = null;

  sport_id = null;
  scope = null; // MATCH|TOURNAMENT|SEASON|CLUB|TRAINING
  include_common = true;

  award_types = [];
  awards = [];

  setContext(ctx = {}) {
    Object.keys(ctx).forEach((k) => this.setProperty(k, ctx[k]));
  }

  setTypeFilter({ sport_id = null, scope = null, include_common = true } = {}) {
    this.sport_id = sport_id;
    this.scope = scope;
    this.include_common = include_common;
  }

  async getAwardTypes(extra = {}) {

    const payload = {
      sport_id: this.sport_id,
      scope: this.scope,
      include_common: this.include_common,
      ...extra
    };

    const ret = await post("award/get_award_types", payload)
      .catch((err) => console.error("--award/get_award_types error", err))


    if (ret && ret.result === 0) {
      this.award_types = ret.award_types || [];
    }
    return ret;
  }

  async listAwards(extra = {}) {
    const payload = {
      company_id: this.company_id || undefined,
      tournament_id: this.tournament_id ?? undefined,
      game_id: this.game_id ?? undefined,
      team_class_id: this.team_class_id ?? undefined,

      sport_id: this.sport_id ?? undefined,
      scope: this.scope ?? undefined,
      include_common: this.include_common,

      limit: 200,
      offset: 0,
      ...extra
    };

    const ret = await post("award/list_awards", payload)
      .catch((err) => console.error("--award/list_awards error", err))


    if (ret && ret.result === 0) {
      this.awards = ret.awards || [];
    }
    return ret;
  }

  async createAward(payload = {}) {


    const req = {
      award_type_id: payload.award_type_id,

      // recipients (new model)
      team_id: payload.team_id ?? null,                 // company_teams
      game_team_id: payload.game_team_id ?? null,       // game_teams
      company_user_id: payload.company_user_id ?? null, // company_users

      // legacy (keep if you still need)
      user_id: payload.user_id ?? undefined,

      // context
      company_id: payload.company_id ?? this.company_id ?? undefined,
      tournament_id: payload.tournament_id ?? this.tournament_id ?? undefined,
      game_id: payload.game_id ?? this.game_id ?? undefined,
      team_class_id: payload.team_class_id ?? this.team_class_id ?? undefined,

      name: payload.name ?? null
    };

    const ret = await post("award/create_award", req)
      .catch((err) => console.error("--award/create_award error", err))


    if (ret && ret.result === 0 && ret.award) {
      this.awards = [ret.award, ...this.awards];
    }
    return ret;
  }

  async updateAward({ award_id, id, ...patch } = {}) {


    const req = {
      award_id: award_id ?? id,
      ...patch
    };

    const ret = await post("award/update_award", req)
      .catch((err) => console.error("--award/update_award error", err))


    if (ret && ret.result === 0 && ret.award) {
      const updated = ret.award;
      this.awards = this.awards.map((a) => (a.id === updated.id ? updated : a));
    }
    return ret;
  }

  async deleteAward({ award_id, id } = {}) {


    const req = { award_id: award_id ?? id };

    const ret = await post("award/delete_award", req)
      .catch((err) => console.error("--award/delete_award error", err))


    if (ret && ret.result === 0) {
      const delId = award_id ?? id;
      this.awards = this.awards.filter((a) => a.id !== delId);
    }
    return ret;
  }
}